import * as React from 'react';
import classnames from 'classnames';
import { SubscriptionContainer } from '../containers/SubscriptionContainer.js';
import { RemoveVoucherCodeContainer } from '../../VoucherCodes/RemoveVoucherCode/RemoveVoucherCodeContainer.js';

const Subscription = ({ className , lineItems , hideSubscriptionExplainer , subscription , voucherCodes  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className)
    }, voucherCodes && voucherCodes.map((code)=>/*#__PURE__*/ React.createElement(RemoveVoucherCodeContainer, {
            key: code,
            voucherCode: code
        })
    ), /*#__PURE__*/ React.createElement(SubscriptionContainer, {
        lineItems: lineItems,
        subscription: subscription,
        hideSubscriptionExplainer: hideSubscriptionExplainer
    }))
;

export { Subscription };
//# sourceMappingURL=Subscription.js.map
